var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "16px",
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.57935,8.71 C1.78839,10.60409 2.8758,12.2342 4.42484,13.18426 C3.75283,12.00037 3.32336,10.43391 3.23492,8.71 L1.57935,8.71 Z M1.57935,7.37 L3.23492,7.37 C3.32336,5.64609 3.75283,4.07963 4.42484,2.89574 C2.8758,3.8458 1.78839,5.47591 1.57935,7.37 Z M13.56565,7.37 C13.35661,5.47591 12.2692,3.8458 10.72016,2.89574 C11.39217,4.07963 11.82164,5.64609 11.91008,7.37 L13.56565,7.37 Z M13.56565,8.71 L11.91008,8.71 C11.82164,10.43391 11.39217,12.00037 10.72016,13.18426 C12.2692,12.2342 13.35661,10.60409 13.56565,8.71 Z M6.9025,13.90719 L6.9025,8.71 L4.57693,8.71 C4.72634,11.28682 5.72196,13.33166 6.9025,13.90719 Z M4.57693,7.37 L6.9025,7.37 L6.9025,2.17281 C5.72196,2.74834 4.72634,4.79318 4.57693,7.37 Z M8.2425,2.17281 L8.2425,7.37 L10.56807,7.37 C10.41866,4.79318 9.42304,2.74834 8.2425,2.17281 Z M10.56807,8.71 L8.2425,8.71 L8.2425,13.90719 C9.42304,13.33166 10.41866,11.28682 10.56807,8.71 Z M7.5725,15.41 C3.50225,15.41 0.2025,12.11025 0.2025,8.04 C0.2025,3.96975 3.50225,0.67 7.5725,0.67 C11.64275,0.67 14.9425,3.96975 14.9425,8.04 C14.9425,12.11025 11.64275,15.41 7.5725,15.41 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "04-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.2-\\u2014-Profile",
    transform: "translate(-1081.000000, -716.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Country",
    transform: "translate(1074.000000, 712.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16x16/Globe",
    transform: "translate(7.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#3A464F",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryIcon);
export default __webpack_public_path__ + "static/media/Country_Icon.850be60c219990aa62c71b876a913db3.svg";
export { ForwardRef as ReactComponent };